/**
 * CUSTOM: Shared scroll-reveal driver for all custom sections.
 *
 * Contract: a section root carries data-reveal-root. This script adds
 * `is-ready` (entrance styles arm — sections hide their children ONLY
 * under .is-ready, so no-JS users always see content) and `is-visible`
 * when the root scrolls into view (entrance animations run once).
 *
 * - prefers-reduced-motion / no IntersectionObserver: nothing is added,
 *   content stays static and visible.
 * - Roots already on screen when this (deferred) script runs are left
 *   static — no hide-then-animate flash.
 * - shopify:section:load re-scans so the Theme Editor stays live.
 *
 * Behavior cue: every root also receives a `reveal:visible` CustomEvent
 * exactly once — when it scrolls into view, or immediately if it stays
 * static (reduced motion, no IO, already on screen). Sections hook
 * one-shot behaviors (count-ups, autoplay starts) to this event instead
 * of creating their own IntersectionObserver.
 */
(function () {
  'use strict';

  var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var supported = 'IntersectionObserver' in window && !reduced;
  var io = null;

  function fire(root) {
    root.dispatchEvent(new CustomEvent('reveal:visible'));
  }

  function observer() {
    if (io) return io;
    io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-visible');
        fire(entry.target);
        io.unobserve(entry.target);
      });
    }, { threshold: 0.15, rootMargin: '0px 0px -10% 0px' });
    return io;
  }

  function bind() {
    document.querySelectorAll('[data-reveal-root]:not([data-reveal-bound])').forEach(function (root) {
      root.setAttribute('data-reveal-bound', '');
      if (!supported || root.getBoundingClientRect().top < window.innerHeight) {
        fire(root); // static — content visible, behaviors still get their cue
        return;
      }
      root.classList.add('is-ready');
      observer().observe(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bind);
  } else {
    bind();
  }
  document.addEventListener('shopify:section:load', bind);
})();
